import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = ({ isAuthenticated = false }) => {
  const navigate = useNavigate();

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-orange-50 flex items-center justify-center p-4">
        <div className="text-center max-w-lg mx-auto">
          <h1 className="text-3xl font-heading font-semibold mb-4 text-neutral-charcoal">
            You Need to Login
          </h1>

          <p className="text-lg text-gray-600 mb-8 font-body leading-relaxed">
            Please login to access this page and start sharing your runs.
          </p>

          <div>
            <button
              onClick={() => navigate('/login')}
              className="w-full px-8 py-4 bg-gradient-vibe text-white font-semibold rounded-xl shadow-lg hover:shadow-xl hover:scale-[1.05] active:scale-[0.95] transition-all duration-200 font-body"
            >
              Go to Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-orange-50 flex items-center justify-center p-4">
      <div className="text-center max-w-lg mx-auto">
        <div className="mb-8">
          <div className="text-8xl font-heading font-bold bg-gradient-vibe bg-clip-text text-transparent drop-shadow-lg">
            404
          </div>
        </div>

        <h1 className="text-3xl font-heading font-semibold mb-4 text-neutral-charcoal">
          Oops! You've Run Off Track!
        </h1>

        <div className="bg-white/70 backdrop-blur-sm rounded-2xl p-6 mb-6 shadow-lg border border-white/20">
          <div className="grid grid-cols-3 gap-4 text-center">
            <div>
              <div className="text-2xl font-bold bg-gradient-vibe bg-clip-text text-transparent">404</div>
              <div className="text-sm text-gray-600">Miles Off Course</div>
            </div>
            <div>
              <div className="text-2xl font-bold bg-gradient-vibe bg-clip-text text-transparent">∞</div>
              <div className="text-sm text-gray-600">Ways Back Home</div>
            </div>
            <div>
              <div className="text-2xl font-bold bg-gradient-vibe bg-clip-text text-transparent">1</div>
              <div className="text-sm text-gray-600">Click to Return</div>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <button
            onClick={() => navigate('/feed')}
            className="w-full px-8 py-4 bg-gradient-vibe text-white font-semibold rounded-xl shadow-lg hover:shadow-xl hover:scale-[1.05] active:scale-[0.95] transition-all duration-200 font-body"
          >
            Get Back to Your Feed
          </button>
          
          <button
            onClick={() => navigate(-1)}
            className="w-full px-8 py-3 bg-white/50 backdrop-blur-sm text-neutral-charcoal font-semibold rounded-xl border border-gray-200 hover:bg-white/70 hover:scale-[1.02] active:scale-[0.98] transition-all duration-200 font-body"
          >
            Go Back Where You Came From
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
